import React from "react"
import PropTypes from "prop-types"
import Text from "../../ui/Text"

const good = new Set(["success"])
const bad = new Set(["crash", "no_astrometry_match"])

const SolveStatus = ({ status }) => {
  const isGood = good.has(status)
  const isBad = bad.has(status)
  return (
    <Text success={isGood} error={isBad} secondary={!isGood && !isBad}>
      {status}
    </Text>
  )
}

SolveStatus.propTypes = {
  status: PropTypes.string,
}

export default SolveStatus
